import React from "react";

function AboutMe() {
  return (
    <div className="about-section">
      <div className="about-inner">
        <div className="about-photo-wrap">
          <img
            className="about-photo"
            src="https://res.cloudinary.com/dvyids286/image/upload/v1661385850/portfolio/fzbl9xqyp8qn1h8dmq6l.jpg"
            alt="Oluwabusola Ilechukwu"
          />
        </div>

        <div className="about-content">
          <div className="section-header" style={{ textAlign: "left", marginBottom: "1.5rem" }}>
            <div className="section-label">About Me</div>
            <h2 className="section-title">Hi, I'm Busola</h2>
          </div>

          <p>
            I'm a frontend-focused full stack developer with a background in
            architecture. Making the switch into tech gave me a fresh perspective
            on problem-solving — I approach code the way I approached design:
            with structure, clarity, and the user always in mind.
          </p>
          <p>
            I trained in full stack web development at Epicode School, where I
            built real-world projects across the full JavaScript ecosystem. I'm
            most at home in React, but I'm equally comfortable on the backend
            with Node.js and MongoDB.
          </p>
          <p>
            Outside of code: travelling, experimenting in the kitchen, and the
            occasional movie marathon.
          </p>

          <div className="about-stats">
            <div className="about-stat">
              <strong>4+</strong>
              <span>Projects shipped</span>
            </div>
            <div className="about-stat">
              <strong>Full Stack</strong>
              <span>JavaScript</span>
            </div>
            <div className="about-stat">
              <strong>Open</strong>
              <span>To opportunities</span>
            </div>
          </div>

          <div className="about-actions">
            <a
              href="https://docs.google.com/document/d/1eHAUsdxh8J53QIvTRZA6ZmZHbiwiTMUaqt-bCDyoVdI/edit?usp=sharing"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              Download Resume
            </a>
            <a href="#contact" className="btn-outline" style={{ borderColor: "#e2e8f0", color: "#334155" }}>
              Get in touch
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
